import React, { useMemo } from 'react'
import { useLocation } from 'react-router'

import KonvaStumpShade from '@/pages/stainingStudio/stumpShade/KonvaStumpShade'
import { useAppSelector } from '@/store'
import { PLACEMENT } from '@/store/appSlice'

import KonvaColorChecker from './KonvaColorChecker'
import KonvaDentin from './KonvaDentin'
import KonvaEnamel from './KonvaEnamel'
import KonvaFLStumpShade from './KonvaFLStumpShade'
import KonvaFLStumpShadeStaining from './KonvaFLStumpShadeStaining'
import KonvaFLWashBake from './KonvaFLWashBake'
import KonvaFMMaterialAdvice from './KonvaFMMaterialAdvice'
import KonvaFrameWork from './KonvaFrameWork'
import KonvaGingiva from './KonvaGingiva'
import KonvaGingivaCeramic from './KonvaGingivaCeramic'
import KonvaGingivaStaining from './KonvaGingivaStaining'
import KonvaInternalEffect from './KonvaInternalEffect'
import KonvaMLEnamel from './KonvaMLEnamel'
import KonvaMLInternalEffect from './KonvaMLInternalEffect'
import KonvaMaterialAdvice from './KonvaMaterialAdvice'
import KonvaOpaquer from './KonvaOpaquer'
import KonvaOpaquerStaining from './KonvaOpaquerStaining'
import KonvaPFMDentin from './KonvaPFMDentin'
import KonvaPFMEnamel from './KonvaPFMEnamel'
import KonvaPFMInternalEffect from './KonvaPFMInternalEffect'
import KonvaWashBake from './KonvaWashBake'

const KonavaElements: React.FC<{
  hiddenCanvasRef: any
  placement: PLACEMENT
  type: string
}> = ({ hiddenCanvasRef, placement }) => {
  const location = useLocation()
  const stumpShadeRecipe = useAppSelector(
    (state) => state.stainingStudio.stumpShadeRecipe,
  )

  const [leftElements, rightElements] = useMemo(() => {
    if (!stumpShadeRecipe) return [[], []]

    const makeCards = (placementKey: PLACEMENT) =>
      Object.values(stumpShadeRecipe[placementKey] || {}).map((recipe) => ({
        component: (
          <KonvaStumpShade
            input={recipe?.input}
            output={recipe?.output}
            tooltipPlacement={placementKey}
          />
        ),
        id: recipe?.input?.basecolor,
      }))

    return [makeCards(PLACEMENT.LEFT), makeCards(PLACEMENT.RIGHT)]
  }, [stumpShadeRecipe])
  return (
    <>
      {location.pathname === '/digital-try-in' ? (
        location?.search?.includes('color_checker') ? (
          <KonvaColorChecker
            hiddenCanvasRef={hiddenCanvasRef}
            placement={placement}
          />
        ) : (
          <></>
        )
      ) : location?.pathname === '/staining-studio/gingiva-staining' ? (
        <KonvaGingivaStaining />
      ) : location.pathname === '/staining-studio/stump-shade' ? (
        <>
          {placement === PLACEMENT.LEFT
            ? leftElements.map((el) => el.component)
            : rightElements.map((el) => el.component)}
        </>
      ) : location?.pathname === '/staining-studio/wash-bake' ? (
        <KonvaWashBake />
      ) : location?.pathname === '/full-layering/framework' ? (
        <KonvaFrameWork />
      ) : location?.pathname === '/micro-layering/material-advice' ? (
        <KonvaMaterialAdvice />
      ) : location?.pathname === '/full-monolithic/material-advice' ? (
        <KonvaFMMaterialAdvice />
      ) : location?.pathname === '/model-making/resin-recipe' ? (
        <KonvaFLStumpShade />
      ) : location.pathname === '/model-making/3d-printed-model-staining' ? (
        <KonvaFLStumpShadeStaining placement={placement} />
      ) : location.pathname === '/full-layering/wash-bake' ? (
        <KonvaFLWashBake />
      ) : location.pathname === '/pfm-crown/opaquer-staining' ? (
        <KonvaOpaquerStaining />
      ) : location.pathname === '/full-layering/dentin' ? (
        <KonvaDentin />
      ) : location.pathname === '/pfm-crown/dentin' ? (
        <KonvaPFMDentin />
      ) : location.pathname === '/full-layering/internal-effects' ? (
        <KonvaInternalEffect />
      ) : location.pathname === '/micro-layering/internal-effects' ? (
        <KonvaMLInternalEffect />
      ) : location.pathname === '/pfm-crown/internal-effects' ? (
        <KonvaPFMInternalEffect />
      ) : location.pathname === '/gingiva/staining' ? (
        <KonvaGingiva />
      ) : location.pathname === '/full-layering/enamel' ? (
        <KonvaEnamel />
      ) : location.pathname === '/micro-layering/enamel' ? (
        <KonvaMLEnamel />
      ) : location.pathname === '/pfm-crown/enamel' ? (
        <KonvaPFMEnamel />
      ) : location.pathname === '/gingiva/ceramic' ? (
        <KonvaGingivaCeramic />
      ) : location.pathname === '/pfm-crown/opaquer' ? (
        <KonvaOpaquer />
      ) : null}
    </>
  )
}

export default KonavaElements
